import { Component, Input } from '@angular/core';
import { EmeraldIconModule } from '@emerald-angular/icon';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-open-positions-flag-legend',
  standalone: true,
  imports: [EmeraldIconModule, CommonModule],
  templateUrl: './open-positions-flag-legend.component.html',
  styleUrl: './open-positions-flag-legend.component.scss',
})
export class OpenPositionsFlagLegendComponent {
  @Input() legendItems: { color: string; label: string }[] = [];
}
